import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Navbar from "../../components/common/Navbar";
import Footer from "../../components/common/Footer";
import businessPartner from "../../assets/images/businesspartner.jpg";

const BusinessPartnersServices = () => {
  return (
    <main>

      <Helmet>
        <title>
          Find Trusted Business Partner in India | Partnership Consultancy
        </title>

        <meta
          name="description"
          content="BusinessMateWorkflow™ helps you find trusted business partners and strategic business partnership solutions for long-term growth."
        />

        <meta
          name="keywords"
          content="business partnership consultancy,find business partner,strategic business partner,startup business partner,business collaboration services"
        />

        <meta
          property="og:title"
          content="Business Partner Services"
        />

        <meta
          property="og:description"
          content="Connect with verified business partners and grow your business confidently."
        />

        <meta
          property="og:image"
          content="https://www.businessmateworkflow.in/uploads/profile-photos/profile-1760447397010-717722877.jpg"
        />

      </Helmet>

      <Navbar />

      {/* HERO SECTION */}
      <section
        style={{
          background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
          padding: "40px 0",
          color: "#fff",
        }}
      >
        <div className="container">
          <div className="row align-items-center">

            {/* LEFT CONTENT */}
            <div className="col-lg-6">
              <span
                style={{
                  background: "#06b590",
                  padding: "8px 18px",
                  borderRadius: "30px",
                  fontSize: "14px",
                  fontWeight: "600",
                  display: "inline-block",
                  marginBottom: "20px",
                }}
              >
                Business Growth & Partnerships
              </span>

              <h1
                style={{
                  fontSize: "52px",
                  fontWeight: "800",
                  lineHeight: "1.2",
                  marginBottom: "25px",
                  color: "#fff",
                }}
              >
                Find Trusted Business Partners for Growth
              </h1>

              <p
                style={{
                  fontSize: "17px",
                  lineHeight: "2",
                  color: "#cbd5e1",
                }}
              >
                One of the biggest challenges in business is finding the right partner who shares the same vision, goals, and commitment. Many startups and businesses fail not because of poor ideas, but because they lack reliable execution support and strong partnerships.
              </p>

              <p
                style={{
                  fontSize: "17px",
                  lineHeight: "2",
                  color: "#cbd5e1",
                  marginTop: "15px",
                }}
              >
                At BusinessMateWorkflow™, our Business Partner Services help entrepreneurs, startups, investors, and companies connect through a structured business networking ecosystem.
              </p>
            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6 text-center mt-5 mt-lg-0">
              <img
                src="/uploads/profile-photos/profile-1760447397010-717722877.jpg"
                alt="Business Partner Services"
                className="img-fluid"
                loading="lazy"
                style={{
                  borderRadius: "25px",
                  boxShadow: "0 25px 60px rgba(0,0,0,0.35)",
                  maxHeight: "550px",
                  objectFit: "cover",
                }}
              />
            </div>

          </div>
        </div>
      </section>

      {/* BUSINESS PARTNERSHIP SOLUTIONS SECTION */}
      <section
        style={{
          padding: "100px 0",
          background: "#f8fafc",
        }}
      >
        <div className="container">

          <div className="text-center mb-5">
            <h2
              style={{
                fontSize: "42px",
                fontWeight: "800",
                marginBottom: "20px",
              }}
            >
              Our Business Partnership Solutions
            </h2>
          </div>

          <div className="row g-4">

            {/* Co-Founder Matching */}
            <div className="col-lg-6">
              <div
                style={{
                  background: "#fff",
                  padding: "35px",
                  borderRadius: "20px",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "48px", marginBottom: "15px" }}>🤝</div>
                <h3
                  style={{
                    fontSize: "24px",
                    fontWeight: "800",
                    marginBottom: "15px",
                    color: "#0f172a",
                  }}
                >
                  Co-Founder Matching
                </h3>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "1.7",
                    color: "#475569",
                  }}
                >
                  Connect with suitable co-founders for startup ideas and business expansion opportunities.
                </p>
              </div>
            </div>

            {/* Investor Connections */}
            <div className="col-lg-6">
              <div
                style={{
                  background: "#fff",
                  padding: "35px",
                  borderRadius: "20px",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "48px", marginBottom: "15px" }}>💰</div>
                <h3
                  style={{
                    fontSize: "24px",
                    fontWeight: "800",
                    marginBottom: "15px",
                    color: "#0f172a",
                  }}
                >
                  Investor Connections
                </h3>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "1.7",
                    color: "#475569",
                  }}
                >
                  Find investment opportunities and connect with investors for business growth support.
                </p>
              </div>
            </div>

            {/* Joint Venture Opportunities */}
            <div className="col-lg-6">
              <div
                style={{
                  background: "#fff",
                  padding: "35px",
                  borderRadius: "20px",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "48px", marginBottom: "15px" }}>🏢</div>
                <h3
                  style={{
                    fontSize: "24px",
                    fontWeight: "800",
                    marginBottom: "15px",
                    color: "#0f172a",
                  }}
                >
                  Joint Venture Opportunities
                </h3>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "1.7",
                    color: "#475569",
                  }}
                >
                  Explore strategic business collaborations and expansion partnerships.
                </p>
              </div>
            </div>

            {/* Business Collaborations */}
            <div className="col-lg-6">
              <div
                style={{
                  background: "#fff",
                  padding: "35px",
                  borderRadius: "20px",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "48px", marginBottom: "15px" }}>🔗</div>
                <h3
                  style={{
                    fontSize: "24px",
                    fontWeight: "800",
                    marginBottom: "15px",
                    color: "#0f172a",
                  }}
                >
                  Business Collaborations
                </h3>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "1.7",
                    color: "#475569",
                  }}
                >
                  Build strong business-to-business partnerships for marketing, distribution, outsourcing, and operational growth.
                </p>
              </div>
            </div>

          </div>

          <div className="text-center mt-4">
            <div
              style={{
                background: "#e6f7f2",
                padding: "15px 25px",
                borderRadius: "12px",
                display: "inline-block",
              }}
            >
              <p style={{ fontSize: "15px", color: "#0f172a", margin: 0 }}>
                💡 Businesses looking to expand operations can also use our Business for Sale & Buy Services to discover new business opportunities.
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* BENEFITS OF BUSINESS PARTNER SERVICES SECTION */}
      <section
        style={{
          padding: "100px 0",
          background: "#fff",
        }}
      >
        <div className="container">

          <div className="row align-items-center">
            <div className="col-lg-6">
              <h2
                style={{
                  fontSize: "42px",
                  fontWeight: "800",
                  marginBottom: "25px",
                }}
              >
                Benefits of Business Partner Services
              </h2>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                }}
              >
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Faster business execution
                </li>
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Strong partnership opportunities
                </li>
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Better business networking
                </li>
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Expansion support
                </li>
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Access to investors and collaborators
                </li>
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Long-term business growth opportunities
                </li>
              </ul>
            </div>

            <div className="col-lg-6 mt-5 mt-lg-0">
              <div
                style={{
                  background: "#f8fafc",
                  padding: "40px",
                  borderRadius: "25px",
                  textAlign: "center",
                  border: "1px solid #e2e8f0",
                }}
              >
                <div style={{ fontSize: "60px", marginBottom: "20px" }}>⭐</div>
                <h3 style={{ fontSize: "28px", fontWeight: "700", marginBottom: "15px", color: "#0f172a" }}>
                  Our Mission
                </h3>
                <p style={{ fontSize: "17px", lineHeight: "1.8", color: "#475569" }}>
                  We aim to create a trusted ecosystem where entrepreneurs and businesses can build meaningful partnerships, unlock growth opportunities, and achieve long-term success through collaboration and strategic networking.
                </p>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* IMAGE AND VISION SECTION - PRESERVED ORIGINAL IMAGE */}
      <section
        style={{
          padding: "100px 0",
          background: "#f8fafc",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <img
                src={businessPartner}
                alt="Business Collaboration"
                className="img-fluid"
                loading="lazy"
                style={{
                  borderRadius: "25px",
                  boxShadow: "0 20px 50px rgba(0,0,0,0.12)",
                }}
              />
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <h2
                style={{
                  fontSize: "42px",
                  fontWeight: "800",
                  marginBottom: "25px",
                }}
              >
                Build Strong Business Relationships
              </h2>
              <p
                style={{
                  color: "#475569",
                  lineHeight: "2",
                  fontSize: "17px",
                }}
              >
                Success in business often depends on the people you surround yourself with. Whether you need a co-founder, investor, joint venture partner, or business collaborator, our platform provides the right connections to help you grow.
              </p>
              <p
                style={{
                  color: "#475569",
                  lineHeight: "2",
                  fontSize: "17px",
                  marginTop: "15px",
                }}
              >
                Join BusinessMateWorkflow™ today and take the first step toward building meaningful business partnerships that drive long-term success.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section
        style={{
          background: "linear-gradient(135deg, #06b590 0%, #059669 100%)",
          padding: "90px 0",
          textAlign: "center",
          color: "#fff",
        }}
      >
        <div className="container">
          <h2
            style={{
              fontSize: "48px",
              fontWeight: "800",
              marginBottom: "20px",
            }}
          >
            Start Your Business Journey Today
          </h2>
          <p
            style={{
              maxWidth: "800px",
              margin: "0 auto",
              fontSize: "18px",
              lineHeight: "1.9",
              marginBottom: "35px",
            }}
          >
            If you are looking for business opportunities, partnerships, employees, or professional services, you can contact us. Our team will understand your requirement and connect you with the right solution.
          </p>

          <Link to="/contact">
            <button
              className="btn"
              style={{
                background: "#fff",
                color: "#06b590",
                padding: "15px 40px",
                borderRadius: "12px",
                fontWeight: "700",
                border: "none",
                fontSize: "18px",
              }}
            >
              Get Started Now
            </button>
          </Link>
        </div>
      </section>

      <Footer />

    </main>
  );
};

export default BusinessPartnersServices;